/**
 * De ING-ingang op favotrip.de: de aan/uit-regel (fixronde 1 op PR 1756).
 *
 * UIT (standaard): favotrip.de gedraagt zich precies als op main. Een
 * Exclusive-adres op .de krijgt de 308 naar https://www.favotrip.nl/exclusive,
 * .de/ing is gewoon de bestaande route, de inlogroute, de bevestig-POST en de
 * klant-proxy (/api/klant-de) geven 404, en de klant-API gaat op .de
 * rechtstreeks naar de API zoals op main.
 *
 * AAN: het gedrag van PR 1756 (src/lib/luxe/ing-de.js): alles binnen .de,
 * inloggen en sessie op .de, de klant-proxy voor de ING-ingang.
 *
 * Eén constante, zonder imports, zodat de middleware, de browser (customer-api)
 * en de routes onder /api precies dezelfde regel lezen. Aanzetten is een
 * aparte PR van één regel plus test (zelfde patroon als
 * src/lib/luxe/luxe-public-flags.js). Een staging-build mag hem aan hebben.
 */
export const ING_DE_LIVE = false;

/** true als de ING-ingang op favotrip.de aan staat. */
export function ingDeLive() {
  return ING_DE_LIVE === true;
}

/**
 * Boeken tegen de ING-prijs vanaf de hotelpagina op favotrip.de/ing/<hotel>
 * (lane 6+7). UIT (standaard): per verblijf een uitgeschakelde knop "Buchung in
 * Kürze möglich", zonder link naar de bestaande boekstraat (die rekent de
 * ledenprijs, niet de ING-prijs). Aanzetten pas als het afrekenen tegen de
 * ING-prijs (backend lane 5 en de frontendlane daarna) live staat, in een
 * aparte PR van één regel plus test.
 */
export const ING_DE_BOEKEN_LIVE = false;

/** true als boeken tegen de ING-prijs op favotrip.de aan staat. */
export function ingDeBoekenLive() {
  return ING_DE_BOEKEN_LIVE === true;
}
